import React from 'react';
interface LogoProps {
  showText?: boolean;
  className?: string;
  variant?: 'dark' | 'light';
  size?: 'sm' | 'md' | 'lg';
}
export function Logo({
  showText = true,
  className = '',
  variant = 'dark',
  size = 'md'
}: LogoProps) {
  const iconSizes = {
    sm: 24,
    md: 32,
    lg: 44
  };
  const textClasses = {
    sm: 'text-base',
    md: 'text-lg',
    lg: 'text-2xl'
  };
  const iconSize = iconSizes[size];
  const textColor = variant === 'light' ? 'text-white' : 'text-gray-900';
  const digitalColor = variant === 'light' ? 'text-blue-300' : 'text-blue-600';
  const iconColor = variant === 'light' ? '#93C5FD' : '#2563EB';
  const iconBg = variant === 'light' ? '#3B82F6' : '#BFDBFE';
  return <div className={`flex items-center gap-2.5 ${className}`} data-id="element-177">
      {/* Isotipo: Document with checkmark */}
      <svg width={iconSize} height={iconSize} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-178">
        <rect x="8" y="6" width="24" height="28" rx="4" fill={iconBg} opacity="0.5" data-id="element-179" />
        <rect x="12" y="10" width="20" height="24" rx="3" fill={iconColor} data-id="element-180" />
        <path d="M17 22L20 25L27 16" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-181" />
        <line x1="16" y1="16" x2="20" y2="16" stroke="white" strokeWidth="2" strokeLinecap="round" data-id="element-182" />
      </svg>

      {/* Text */}
      {showText && <span className={`tracking-tight leading-none ${textClasses[size]}`} data-id="element-183">
          <span className={`font-semibold ${textColor}`} data-id="element-184">Inspect</span>
          <span className={`font-bold ${digitalColor}`} data-id="element-185">IA</span>
        </span>}
    </div>;
}